// extracted by mini-css-extract-plugin
module.exports = {"Tit":"CorporateServices_Tit__2ITBM","Title":"CorporateServices_Title__2SYyD","Desc":"CorporateServices_Desc__3CN4q","AddPadding":"CorporateServices_AddPadding__2pFU5"};